import SummitBoldSolid from "./SummitBold-Solid.ttf";
import SummitLightSolid from "./SummitLight-Solid.ttf";
import MontserratExtraLight from "./Montserrat-ExtraLight.otf";
import MyriadProBold from "./MYRIADPRO-BOLD.OTF";
import MyriadProRegular from "./MYRIADPRO-REGULAR.OTF";

const SummitBoldSolidName = "summitbold-solid";
const SummitLightSolidName = "summitlight-solid";
const MontserratExtraLightName = "montserrat-extralight";
const MyriadProBoldName = "myriadpro-bold";
const MyriadProRegularName = "myriadpro-regular";

export {
    SummitBoldSolid,
    SummitBoldSolidName,
    SummitLightSolid,
    SummitLightSolidName,
    MontserratExtraLight,
    MontserratExtraLightName,
    MyriadProBold,
    MyriadProBoldName,
    MyriadProRegular,
    MyriadProRegularName
};